/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Table_DateInputs */

const en_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const fr_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const es_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const it_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const nl_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const pl_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const fi_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivämäärä`)
};

const da_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dato`)
};

const sv_settings_table_date = /** @type {(inputs: Settings_Table_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Settings_Table_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_table_date = /** @type {((inputs?: Settings_Table_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Table_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_table_date(inputs)
	if (locale === "fr") return fr_settings_table_date(inputs)
	if (locale === "es") return es_settings_table_date(inputs)
	if (locale === "it") return it_settings_table_date(inputs)
	if (locale === "nl") return nl_settings_table_date(inputs)
	if (locale === "pl") return pl_settings_table_date(inputs)
	if (locale === "fi") return fi_settings_table_date(inputs)
	if (locale === "da") return da_settings_table_date(inputs)
	if (locale === "sv") return sv_settings_table_date(inputs)
	return en_settings_table_date(inputs)
});